import {
  ConditionalRuleKind,
  ConditionalRuleConfig
} from '../../../Controls/Shared/RulesEngine/types';
import { conditionalRuleDictionary } from '../../../Controls/Shared/RulesEngine/getConditionalRules';
import { SelectOption } from '../../../Controls/Select/types';
import getControlSchemaProperty from '../../../Shared/jsonSchemaUtilities/getControlSchemaProperty';
import getControlsUtilizeHiddenComponents from '../getControlsUtilizeHiddenComponents';
import PageState from '../../../Shared/pageState';
import controlDictionary from '../../../Controls/controlDictionary';

export default (
  pages: PageState[],
  workflowData: Record<string, unknown>
): string[] => {
  let controlIdsToShow: string[] = [];

  const controlsThatUtilizeHiddenComponents =
    getControlsUtilizeHiddenComponents(pages);

  for (const control of controlsThatUtilizeHiddenComponents) {
    const configuredOptions = getControlSchemaProperty(
      control,
      'options'
    ) as unknown as SelectOption[];

    const configuredRules = getControlSchemaProperty(
      control,
      'rules'
    ) as unknown as ConditionalRuleConfig[];

    const controlDefaultValue =
      controlDictionary[control.kind].getDefaultValue(control);
    const controlDataProperties = Object.keys(controlDefaultValue);

    // determine list of controls that qualify to be visible based on configured rules and options
    for (const property of controlDataProperties) {
      const fieldValue = workflowData[property] as string;
      const isNumericValue = !isNaN(parseFloat(fieldValue));

      if (configuredOptions?.length) {
        // get controls that qualify with configured options
        for (const option of configuredOptions) {
          if (fieldValue?.toString().split('|').includes(option.value)) {
            controlIdsToShow = [
              ...controlIdsToShow,
              ...option.utilize.split('|')
            ];
          }
        }
      } else if (configuredRules?.length && isNumericValue) {
        // get controls that qualify with configured rules
        for (const config of configuredRules) {
          const isRuleValidForUpdatedValue = conditionalRuleDictionary[
            config.rule as ConditionalRuleKind
          ]?.validate(parseFloat(fieldValue), config.value1, config.value2);
          if (isRuleValidForUpdatedValue) {
            controlIdsToShow = [
              ...controlIdsToShow,
              ...config.utilize.split('|')
            ];
          }
        }
      }
    }
  }

  // remove duplicates
  controlIdsToShow = controlIdsToShow.filter(
    (item, pos) => controlIdsToShow.indexOf(item) == pos
  );

  return controlIdsToShow;
};
